// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// import 'babel-polyfill'

import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store' 

// 引入vue中的弹窗组件
//import { Confirm, Alert, Toast, Notify, Loading } from 'vue-ydui/dist/lib.rem/dialog';
// Vue.prototype.$dialog = {
//     confirm: Confirm,
//     alert: Alert,
//     toast: Toast,
//     notify: Notify,
//     loading: Loading,
// }

import { Alert } from 'vue-ydui/dist/lib.rem/dialog';
Vue.prototype.$dialog = {
    alert: Alert, 
}

import  myLoading  from "@/components/common/loading"; 
Vue.component("my-loading", myLoading); 

import {CheckBox, CheckBoxGroup} from 'vue-ydui/dist/lib.rem/checkbox';
Vue.component(CheckBox.name, CheckBox);
Vue.component(CheckBoxGroup.name, CheckBoxGroup);

import {Radio, RadioGroup} from 'vue-ydui/dist/lib.rem/radio';
Vue.component(Radio.name, Radio);
Vue.component(RadioGroup.name, RadioGroup);

Vue.config.productionTip = false 

import './config/flexible';
//图片懒加载
import VueLazyload from 'vue-lazyload'    	// 懒加载
import img_load from "./assets/loading.gif";
import img_err from "./assets/error.jpg"; 
Vue.use(VueLazyload,{
  preLoad: 1.3,
  error: img_err,
  loading: img_load,
  attempt: 1 
})

import myXuhaoPlugin from "./myMixin";
Vue.use(myXuhaoPlugin); 

/* eslint-disable no-new */
new Vue({
  el: '#app', 
  router,
  store,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js